var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{opacity:.18;fill:#d57845;enable-background:new}.st1{fill:none;stroke:#d57744;stroke-miterlimit:10;stroke-dasharray:6}.st2{fill:#cbd5fc}.st3{fill:#aabbfc}.st4{fill:none;stroke:#4d635c;stroke-miterlimit:10}.st5{fill:#5768b9}.st6{fill:none;stroke:#fcfcfc;stroke-linecap:round;stroke-miterlimit:10}.st7{opacity:.11;fill:#3e4d7f;enable-background:new}.st8{fill:#fcfcfc}.st9{opacity:.23;fill:#a3c6e0;enable-background:new}.st10{fill:none;stroke:#aabbfc;stroke-width:3;stroke-miterlimit:10}.st11{fill:none;stroke:#a3c6e0;stroke-width:3;stroke-miterlimit:10}.st12{fill:#54649a}.st13{fill:none;stroke:#aabbfc;stroke-miterlimit:10}.st14{fill:#dfbba2}.st15{fill:none;stroke:#ba8772;stroke-width:.5;stroke-linecap:round;stroke-miterlimit:10}.st16{fill:#d57744}.st17{fill:#2d3860}.st18{fill:#fff}.st19{fill:#f1f1f1}.st20{fill:#edc660}.st21{fill:none;stroke:#16171d;stroke-linecap:round;stroke-miterlimit:10}.st22{fill:none;stroke:#ba8772;stroke-width:.5;stroke-linecap:round;stroke-linejoin:round}.st23{fill:none;stroke:#f1f1f1;stroke-width:.366;stroke-miterlimit:10}.st24{fill:none;stroke:#c56735;stroke-width:.75;stroke-linecap:round;stroke-miterlimit:10}.st25{opacity:.23;fill:#54649a;enable-background:new}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_74447",
    transform: "translate(-25.418 -36.545)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32637",
    className: "st0",
    d: "M284.6 84.1c57.1-1.4 109.3 22.1 138.9 61 59.6 78.2 70.6 156.3 30.6 197.4-18.5 18.3-41.9 31-67.4 36.5-56.8 11.9-81.5-23.5-128.5-14.4-62.1 12.1-68.7 83.7-110.5 85.9-39.9 2-83.5-60.7-89.9-119.9C46.8 228.1 143 97.9 269.2 85.1 274.4 84.6 279.6 84.3 284.6 84.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32638",
    className: "st1",
    d: "M168.2 173.5c3.8 20.5-7.4 39.9-24.6 45.8-15.9 5.4-37.4-1.9-38.7-9.6-.5-2.9 1.7-7.4 3.9-7.6 1.5-.1 3.2 1.6 3.7 3.3 1.1 4.1-4.3 9.9-9 11.5-7.2 2.6-17.2-2.8-24.7-13.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32639",
    className: "st1",
    d: "M412.3 113c19.6 7.2 30.6 26.8 26.8 44.5-3.5 16.4-20.7 31.2-28 28.4-2.7-1.1-5.5-5.2-4.6-7.3.6-1.4 3-2 4.8-1.5 4.1 1.2 6.3 8.7 5.4 13.6-1.5 7.5-11.2 13.4-24.2 14.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_67533"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32649",
    className: "st2",
    d: "M419.8 310.9c0 0 18.8-17.1 16.2-25.6-2.5-8.5 1.8-18-4-28.3-5.8-10.3-8.5-8.5-22.2-11s-15.8-9.9-27.9-.6c-11.9 9.1-9.3 14.9 5.7 16.2 9 .8 20.1-1.8 21.1 14.6C409.6 288.4 413.4 300.3 419.8 310.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32650",
    className: "st3",
    d: "M427.6 347.8c-4.5-3.3 1.2-16.4 9.9-22.6 6-4.3 11.1.5 19.8-5 6.1-3.9 6.3-8 10.9-8.5 5.4-.5 6.8 5.1 14.9 7.8 7.8 2.6 10.3-1.4 15.1 1.2 8.7 4.8 12.8 25.1 6.6 30.4-3.8 3.3-10.9-8.8-20.4-6.1-4.7 1.3-5 4.8-9.7 5.4-6.5.9-9-5.4-15.6-7.3C446.5 339.5 432.7 351.5 427.6 347.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32651",
    className: "st4",
    d: "M384.2 435c7.8-25.5 23.8-67.3 38.4-84.4 23.8-27.6 50.2-25.5 50.2-25.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32652",
    className: "st4",
    d: "M396.5 388.5c30.2-101.3 36.7-116.1 28.2-124.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32653",
    className: "st2",
    d: "M400.6 397.2c0 0 .8-21.2 7.7-23.9s10.9-10.5 20.6-11.9 10 1.2 18.7 8.9 14.7 5.2 14.8 18c.1 12.5-4.9 13.8-13.6 4.6-5.2-5.5-9.2-14.1-20.4-6.3C420.1 392.2 410.6 395.9 400.6 397.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32654",
    className: "st4",
    d: "M386.9 435.6c5.8-22.5 16.6-52 34.6-63"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_67536"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_67534"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_2739",
    className: "st5",
    d: "M256.7 141.5h31.9v27.8H256.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32655",
    className: "st5",
    d: "M294 157.3h-42.6v-28.7.0c13.9-3.9 28.7-3.9 42.6.0v0V157.3z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32656",
    className: "st6",
    d: "M254.1 130.3c0 0 14.6 5.6 36.9.0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_67535"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32657",
    className: "st6",
    d: "M254.1 135.5c0 0-.7 13.3 1.1 19.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32658",
    className: "st6",
    d: "M259.8 136.6c0 0-.2 16.1.9 18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32659",
    className: "st6",
    d: "M266.3 137.6c0 0-.6 11.1 1 16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32660",
    className: "st6",
    d: "M290.5 135.5c0 0 .7 13.3-1 19.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32661",
    className: "st6",
    d: "M284.8 136.6c0 0 .2 16.1-.9 18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32662",
    className: "st6",
    d: "M278.3 137.6c0 0 .6 11.1-1 16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32663",
    className: "st6",
    d: "M272.4 137.6c0 0 .1 14-.3 16"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_673",
    className: "st7",
    cx: 278.8,
    cy: 453.8,
    rx: 124.8,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_67538"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_34809",
    className: "st8",
    d: "M275.2 180.6c70.8.0 128.2 57.4 128.2 128.2S346 437.1 275.2 437.1s-128.2-57.4-128.2-128.2S204.4 180.6 275.2 180.6c0 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32664",
    className: "st5",
    d: "M161.6 386.5c0 0-22.7 65.3-15.8 67.2s56.1-39.5 56.1-39.5L161.6 386.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32665",
    className: "st5",
    d: "M388 386.5c0 0 22.7 65.3 15.8 67.2s-56.1-39.5-56.1-39.5L388 386.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32666",
    className: "st5",
    d: "M275.2 165.2c-79.3.0-143.6 64.3-143.6 143.6s64.3 143.6 143.6 143.6c79.3.0 143.6-64.3 143.6-143.6C418.8 229.5 354.5 165.2 275.2 165.2c0 0 0 0 0 0zM275.2 437.1c-70.8.0-128.2-57.4-128.2-128.2.0-70.8 57.4-128.2 128.2-128.2 70.8.0 128.2 57.4 128.2 128.2.0.0.0.0.0.0C403.4 379.7 346 437.1 275.2 437.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32667",
    className: "st9",
    d: "M270.2 314.9h8.5l-4.3-75.5L270.2 314.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32668",
    className: "st5",
    d: "M268.9 313.2h8.5l-4.3-75.5L268.9 313.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32669",
    className: "st9",
    d: "M270.4 312.7l6.4 5.6 62.2-78.4L270.4 312.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32670",
    className: "st5",
    d: "M269.2 311l6.4 5.6 62.2-78.4L269.2 311z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_676",
    className: "st9",
    cx: 273.2,
    cy: 310.9,
    r: 10.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_677",
    className: "st9",
    cx: 273.2,
    cy: 314.9,
    r: 10.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_678",
    className: "st5",
    cx: 273.2,
    cy: 313.2,
    r: 10.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32671",
    className: "st9",
    d: "M268.4 316.4c.8 2.6 3.5 4.1 6.1 3.4 3.2-.9 4.7-5.5 2.7-8.1-1.4-1.8-3.9-2.3-5.9-1.4C268.9 311.3 267.7 313.9 268.4 316.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_67537"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_396",
    className: "st10",
    d: "M275.2 187.3V199.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_397",
    className: "st10",
    d: "M214.4 203.6 220.5 214.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_398",
    className: "st11",
    d: "M169.9 248.1 180.5 254.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_399",
    className: "st10",
    d: "M153.6 308.8H165.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_400",
    className: "st10",
    d: "M169.9 369.6 180.5 363.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_401",
    className: "st10",
    d: "M214.4 414.1 220.5 403.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_402",
    className: "st10",
    d: "M275.2 430.4V418.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_403",
    className: "st10",
    d: "M335.9 414.1 329.8 403.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_404",
    className: "st11",
    d: "M380.4 369.6 369.8 363.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_405",
    className: "st11",
    d: "M396.7 308.8H384.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_406",
    className: "st10",
    d: "M380.4 248.1 369.8 254.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_407",
    className: "st10",
    d: "M335.9 203.6 329.8 214.2z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32672",
    className: "st2",
    d: "M275.2 187.3c69.5.0 126.3 55.3 128.2 124.8.0-1.1.0-2.1.0-3.2.0-70.8-57.4-128.2-128.2-128.2S146.9 238 146.9 308.8c0 1.1.0 2.1.0 3.2C148.9 242.6 205.7 187.3 275.2 187.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32673",
    className: "st12",
    d: "M268.4 314.7c.8 2.6 3.5 4.1 6.1 3.4 3.2-.9 4.7-5.5 2.7-8.1-1.4-1.8-3.9-2.3-5.9-1.4C268.9 309.6 267.7 312.2 268.4 314.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32674",
    className: "st13",
    d: "M303.5 171.9c0 0 60.4 9.5 90.1 66.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32675",
    className: "st13",
    d: "M273 443c0 0-61.1 1.6-100.6-48.8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_67546"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_67539"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32676",
    className: "st14",
    d: "M318 263c.4.4.5.3.7.7.8 1.1 3.3 2.1 4.7 2.6 2.5 2 6.5 6 7.3 2.1.8-3.5 1.4-5.2.8-7.2.0-.2-1.5-1.1-1.6-1.4-1.1-2.2-2.4-4.4-3.7-6.4-2-2.9-4.7-1.3-4.3-.4.1.3 4.9 2.3 4 1.8-.5-1-1.3-1.7-2.2-2.3-2.5-1.8-5.1.1-3.1 1.5.7.2 1.4.3 2.2.3.1.0.2.1.2.1.0.1-1-.7-1.6-1-2.6-1.6-4.3.9-3.6 1.9.3.4 2.2-.2 2.5.1.3.3-2-1.4-2.8-.9-1.9 1.4-1.3 4.9-.8 5.8l1.9-1.8c-.1-.1.7 1.2 1.1 1.9.3 1 .3.8-.1.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32677",
    className: "st15",
    d: "M318 254.3c1.1.0 2.1.5 2.7 1.4l1 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32678",
    className: "st15",
    d: "M320.1 252.8c0 0 1.6.5 2.2.8s1.7 2 1.7 2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32679",
    className: "st15",
    d: "M322.5 251.8c0 0 1.8 1 2.1 1.1s1.1 1.6 1.1 1.6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32680",
    className: "st7",
    d: "M435 488.5c0 1.4-17.3 2.5-38.7 2.5s-38.7-1.1-38.7-2.5 17.3-2.5 38.7-2.5S435 487.1 435 488.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32681",
    className: "st14",
    d: "M417.9 375.8c-.2 1.8-.8 4.4-1.2 6.4-.5 2.7-1.9 2.6-1.8 1.5.0-.4.8-6.6.9-7 .1-.3-.3-.3-.5 1 0 0-.4 1.6-.6 3-.7 3.4-1.9 2.7-1.9 1.8.0-.3.5-5.8.5-6.2.0-.1-.1-2.5-.2-3.2-.2-1.1-.4-1.3-.6-.7-.3 2.7-.9 4.5-1.7 4-.7-.4-.2-3.3-.1-5.3.2-1.8.9-3.5 1.8-5 1-2.7 2.7-6.8 5.1-4.2 1.9 2.1 3.4 4.6 4.2 7.3.1.3.1.6.2.9.1 1.9.1 3.8-.1 5.7-.2 3.1-1.3 3.9-1.4 3.1.0-.3.3-5.2-.1-4.3-.1 1.8-.7 3.9-.9 5.9-.3 2.7-1.6 2.5-1.6 1.4.0-.4.5-5.3.5-5.7.0-.1.0-.6-.2-.6C418 375.5 417.9 375.6 417.9 375.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32682",
    className: "st16",
    d: "M330.4 261.1l25.8 21.6-3.2-1.7 24.4 5.8-2.7 19.4-24.9-11.8-2-.5-1.1-1.2L323.8 268 330.4 261.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32683",
    className: "st17",
    d: "M404.2 352.8c0 0 8.6 35.7 10.7 66 0 0-7.8 6.6-15.2 7.6.0.0-12.7-28.3-22.5-55.3L404.2 352.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32684",
    className: "st17",
    d: "M396.2 360.5c0 0-8 35.4-21 65.5.0.0-8.9 1.4-16-.9.0.0 2.7-43.6 7.2-74.1L396.2 360.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32685",
    className: "st14",
    d: "M380.1 284.2c2-1.3 1.2-5.9 1-8.3l11.8-9.1c0 .3.1 9.8.1 10.1.7 4.4 8.3 9.2 9.1 9.6 4.6 2.6-2.1 26.2-25.6 13.2-.1-.1-.2-.1-.3-.2C371.6 296.9 376.1 286.8 380.1 284.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32686",
    className: "st16",
    d: "M364.2 307.6c.1-2 .9-14.3 8.2-19.4 2.5-1.5 5-2.9 7.7-4 .5 1.4.9 4 5.2 4.1 9.1.1 11.5-5.8 11.5-5.8 6 4.7 7.8 4.1 9.6 5.6 5.6 4.9 9.6 7.2 2.3 25.9l-4.6 21.8 2.3 19.5c-20.5 9.7-33.5 9.3-40.7.2C365.7 355.4 363.1 329.4 364.2 307.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32687",
    className: "st18",
    d: "M390.6 289.2l-6.9 7.5-4.3-7.4L390.6 289.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32688",
    className: "st17",
    d: "M387.1 289.6c0 0-2.5 4-6.1-.5l3.4-1L387.1 289.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_67540"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32689",
    className: "st16",
    d: "M420.9 366.6c0-.2.1-.3.1-.5L420.9 366.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32690",
    className: "st16",
    d: "M420.8 366.9c0 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32691",
    className: "st16",
    d: "M420.8 366.9v-.1V366.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32692",
    className: "st16",
    d: "M421 366l.1-.3L421 366z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32693",
    className: "st16",
    d: "M420.8 366.7v-.2V366.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32694",
    className: "st16",
    d: "M421 365.7c0-.1.0-.1.0-.2C421.1 365.5 421.1 365.6 421 365.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32695",
    className: "st16",
    d: "M426 328.6c-2.6-6.4-6.5-20.9-11.5-31.9-4.7-10.2-18.1-16.9-13.3 5.3 1.5 6.9 7 21.3 11.7 30.1l-.8 32.5c2.3.2 9.2-.2 9.2-.2C422.5 358.6 426 328.6 426 328.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32696",
    className: "st16",
    d: "M421.3 364.5v.2V364.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32697",
    className: "st16",
    d: "M421.1 365.5c0-.2.1-.4.1-.6C421.2 365 421.1 365.2 421.1 365.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32698",
    className: "st16",
    d: "M421.3 364.4v.1V364.4z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32699",
    className: "st19",
    d: "M411.7 364.6c0 0 7.1-.5 10-1.1.0.0.6 2.9-.5 3.9s-8.1 1.5-8.9.6C411.5 367.1 411.7 364.6 411.7 364.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32700",
    className: "st20",
    d: "M412.8 366.5c.2.1.5.0.6-.2.1-.2.0-.5-.2-.6-.2-.1-.5.0-.6.2.0.0.0.0.0.0C412.5 366.2 412.6 366.4 412.8 366.5c0 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32701",
    className: "st19",
    d: "M333.3 262.1c0 0-5.8 6.2-7.8 9.1.0.0-2.9-2-2.7-3.8s5.8-7.8 7.3-7.7C331.5 259.8 333.3 262.1 333.3 262.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32702",
    className: "st20",
    d: "M325 267.3c-.3.1-.4.4-.3.7.1.3.4.4.7.3.3-.1.4-.4.3-.7C325.6 267.4 325.3 267.2 325 267.3c0 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32703",
    className: "st21",
    d: "M387.3 396.5l-5-9.9-7.4-3.9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_67541"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32704",
    className: "st17",
    d: "M427.1 463.7l-27.6-37.6 10.8-13.9c0 0 9.6 8 13.1 15.9 6.9 16 11.1 24.6 13.5 29.3C434.1 459.9 430.5 462.5 427.1 463.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32705",
    className: "st14",
    d: "M431.8 470.2l-4.8-6.5c3.5-1.2 7-3.8 9.8-6.3 2.8 5.3 3.3 5.5 3.3 5.5S438.4 468 431.8 470.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_67542"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32706",
    className: "st17",
    d: "M354.5 473.3l5.1-50.5 16-2c0 0 .8 20.8-1.9 29-4 12-6.2 19.7-7.5 24.8C362.2 474.6 358.3 474.1 354.5 473.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32707",
    className: "st14",
    d: "M364.6 481.7c-3.3 2.3-7.5 2.6-11.1.7l.9-9.1c3.8.9 7.8 1.3 11.7 1.3C364.6 481.4 364.6 481.7 364.6 481.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_67543"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32708",
    className: "st14",
    d: "M380.8 250.4c0 0-4.5 2.7-4.4 7.7-.4 2.6-.9 5.2-1.5 7.7-.8 7.9 4.1 13.2 6 13.3 3.9.0 7.7-1.5 10.5-4.2 4.1-3.9 6.6-17.3 3.4-21.7C390.4 247.3 383 247.8 380.8 250.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32709",
    className: "st17",
    d: "M392.6 265.9c-.1-1-.7-6.7-.4-7.9-.3-.1-.6-.2-.9-.2-2-.1-3.6-1.8-3.6-3.8v0c-2.6.0-5.2-.2-7.8-.7-5-1-3.7-6.7-3.6-6.8 1.3-.3 12.2-2 18.3 2 6.1 3.9 3.1 13.6 2.6 15.2.0.1-.2.2-.3.2l-3.9 2.2C392.8 266.2 392.7 266.1 392.6 265.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32710",
    className: "st17",
    d: "M397 251c0 0 4.8 2.7 1 11.9C398 263 394.9 259.9 397 251z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32711",
    className: "st14",
    d: "M377.2 259c-1.2 2.3-2.8 4.5-4.6 6.3-.9.8 1.8 3.6 3 3.7C378.3 269.3 377.2 259 377.2 259z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32712",
    className: "st14",
    d: "M397.6 267.2c-1.2 2.2-3.5 3.1-5 2.1-1.5-1-1.8-3.6-.5-5.7s3.5-3.1 5-2.1C398.6 262.5 398.8 265.1 397.6 267.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32713",
    className: "st15",
    d: "M391.6 272.5c0 0-1.8 6-9.3 6.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32714",
    className: "st17",
    d: "M381.3 269.5c-.9 1.3-2.5 2-4 1.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32715",
    className: "st17",
    d: "M378.8 262.2c0 .4.2.8.5.8s.5-.3.6-.7-.2-.8-.5-.8S378.8 261.8 378.8 262.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32716",
    className: "st22",
    d: "M396.3 262.8c-1.1-.3-2.3.4-2.6 1.5.0.0.0.1.0.1.0.0 1.6.6.8 1.4s-.9.8-.9.8c-.1.6.2 1.1.6 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32717",
    className: "st17",
    d: "M381.6 260.3c.2-.3.1-1.2-1.1-1.8-.4-.2-1-.2-1.4-.1-.2.1-.3.4-.2.6.1.4.7.2 1.5.8.5.4.3.5.9.6C381.3 260.4 381.5 260.4 381.6 260.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_67544"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32718",
    className: "st18",
    d: "M393.9 279c0 0-4.2 7.2-9.5 9.1 2 1 4 2.2 5.9 3.4.0.0 7.3-6.9 7.8-8.2C397.6 281.3 396 279.6 393.9 279z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32719",
    className: "st18",
    d: "M381.2 282.5l-.7 2.6 4 3c0 0-3.2 1.4-4.6 2.3-1.1-1.4-1.7-3.2-1.7-5.1C378.5 284 379.7 282.9 381.2 282.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32720",
    className: "st17",
    d: "M394.5 250.2c0 0-2.5-4-15.1-6.2C379.4 243.9 377.3 249.9 394.5 250.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32721",
    className: "st17",
    d: "M396.2 249.9c0 0-2.4-3.2-10-5.4C386.2 244.4 385.7 248.6 396.2 249.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32722",
    className: "st17",
    d: "M395.1 250.7c0 0 0-1.8 2.4-3.6C397.5 247.1 398.8 249.2 395.1 250.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32723",
    className: "st17",
    d: "M395 250.5c0 0 1.2-1.2 4.3-.8C399.4 249.7 398.7 252.1 395 250.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32724",
    className: "st23",
    d: "M377.3 262.2c0 1.6 1 2.9 2.2 2.9s2.2-1.3 2.2-2.9c0-1.6-1-2.9-2.2-2.9S377.3 260.6 377.3 262.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32725",
    className: "st23",
    d: "M377.4 261.5c-.2-.5-.8-.8-1.4-.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32726",
    className: "st17",
    d: "M384.1 290.5l3 2.5-3.4 3.7-2.5-4.3L384.1 290.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32727",
    className: "st17",
    d: "M351.2 482.6v0c2-.9 1.2-3.9 3.6-2.2 1.5 1.1 2.3 3 3.9 3.2 2.1-.1 4.2-.7 5.9-1.9v0h.4c0 0 1.7 3 1.2 8.9.0.3-.3.6-.6.6l-6.2.4c-5.8-2-4.5 1.7-21-.3-.3.0-.5-.3-.6-.5C337.6 489 337.8 483.5 351.2 482.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32728",
    className: "st17",
    d: "M429 471v0c1-1.9-1.4-3.8 1.5-4 1.9-.1 3.7 1 5.1.2 1.6-1.3 2.8-3.1 3.5-5.1v0l.3-.3c0 0 3.2 1.3 6.4 6.3.2.3.1.6-.1.9l-4.7 4c-5.8 2-2.5 4.1-16.8 12.6-.3.2-.6.1-.8-.1C422.2 484.3 419 479.8 429 471z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_408",
    className: "st23",
    d: "M381.6 262.2 392.5 263z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_67545"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_409",
    className: "st24",
    d: "M407.1 319.5 403.5 308.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32729",
    className: "st24",
    d: "M367 295.2c-1 2-1.7 4.1-2 6.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32732",
    className: "st24",
    d: "M401.3 335.2c-1.2.0-9.3 1.2-6.2 1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32733",
    className: "st24",
    d: "M400.5 336.1c0 0-4.6 3-2.5 3.5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_67547"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32734",
    className: "st25",
    d: "M148.9 248.6c-1.6.1-3 .2-4.2.2-8 17.3-12.4 35.9-13 54.9.9 1.2 1.6 1.9 1.6 1.9 6.8-8.8 11.5-19 13.6-29.9 2.6-14.5 12.3-11 20.4-10.8 13.6.4 16.5-4.5 6.8-13.9C164.1 241.4 161.4 247.8 148.9 248.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32735",
    className: "st2",
    d: "M133.2 299.9c0 0-15-17.3-11.8-24.6 3.2-7.4.3-16.3 6.6-24.9 6.3-8.6 8.5-6.8 21-7.5s15.2-7.2 25.1 2.4c9.7 9.4 6.8 14.3-6.8 13.9-8.1-.2-17.8-3.7-20.4 10.8C144.7 280.9 140 291.2 133.2 299.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32736",
    className: "st3",
    d: "M113.8 289.6c4.4-2.5.7-14.8-6.5-21.3-4.9-4.5-10-.7-17.2-6.5-5.1-4.1-4.8-7.8-8.8-8.7-4.8-1-6.6 3.8-14.2 5.4-7.3 1.5-9.1-2.3-13.6-.5-8.3 3.4-14.1 21.1-9.1 26.5 3.1 3.3 10.7-6.7 18.9-3.3 4.1 1.7 4 4.8 8.1 5.8 5.7 1.5 8.7-3.9 14.7-4.9C97.8 280.2 108.9 292.4 113.8 289.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32737",
    className: "st4",
    d: "M143.5 372.1c-4.3-23.7-14.2-62.7-25.5-79.5-18.3-27.2-42.2-28.1-42.2-28.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32738",
    className: "st4",
    d: "M145.9 371.8c-16.4-93.8-20.6-107.7-12.2-114.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32739",
    className: "st2",
    d: "M132.8 336.6c0 0 1.5-19-4.4-22.2-5.9-3.2-8.6-10.5-17.2-12.8s-9 0-17.6 6-13.7 3.2-15.1 14.6c-1.4 11.2 3 12.8 11.7 5.6 5.2-4.4 9.7-11.6 18.9-3.5C115.9 330.1 124 334.4 132.8 336.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32740",
    className: "st4",
    d: "M141 372.4c-2.9-20.7-9.4-48.3-24.4-60"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTime);
export default __webpack_public_path__ + "static/media/ico-time.1e587ad18348ee3eda3f088060de3cc0.svg";
export { ForwardRef as ReactComponent };